import { queryOptions } from '@tanstack/react-query';

import { catalogApi } from './catalog.api';

export const catalogOptions = {
  spot: () =>
    queryOptions({
      queryKey: ['spotCatalog'] as const,
      queryFn: catalogApi.getSpotCatalog,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000
    }),
  forward: () =>
    queryOptions({
      queryKey: ['forwardCatalog'] as const,
      queryFn: catalogApi.getForwardCatalog,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000
    })
};
